export default "__VITE_ASSET__BXhTpNir__"